export default {
  PORTFOLIO_VALUATION(state, resp) {
    state.portfolioValuation = resp;
  },
};
